import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from './slices/authSlice';
import { authApi } from './apis/authApi';
import { adminApi } from "./apis/adminApi";
import { userApi } from './apis/userApi';
import { Api } from './apis/api';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authApi.reducerPath]: authApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [Api.reducerPath]: Api.reducer,
  },
  
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
  .concat(authApi.middleware)
  .concat(userApi.middleware)
  .concat(Api.middleware)
  .concat(adminApi.middleware)
});

setupListeners(store.dispatch);